// extracted by mini-css-extract-plugin
module.exports = {"root":"Questions_root__DcJ_p"};